import { css } from '@emotion/css'
import { minScreen } from 'utils/mediaQueries'
import { Color } from 'utils/variables'

export const wrapper = css`
  width: 92vw;
  max-height: 80vh;
  margin: auto;
  padding: 30px;
  background: ${Color.White};
  border-radius: 20px;
  box-sizing: border-box;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar{
    display: none;
  }
  ${minScreen('md')} {
    width: 510px;
  }
`;

export const closeButtonWrap = css`
  text-align: center;
`;
export const closeButton = css`
  margin-top: 15px;
  cursor: pointer;
  display: inline-block;
  ${minScreen('md')} {
    margin-top: 20px;
  }
`;